import { Component, OnInit } from '@angular/core';
import { TopService } from '../../shared/services/top.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss'],
    standalone: true,
    imports: [RouterLink]
})
export class ThankYouComponent implements OnInit {

  constructor(
  	public topService: TopService
  	) { }

  ngOnInit() {
  	document.documentElement.scrollTop = 0;
  }

}
